export class EstudioParameters {
    CompanyId: number;
    CompanyStartDate: string;
    ReportStartDate: string;
    ReportEndDate: string;
    CompareWithPreviousYear: boolean;
    CompanyLevels: string;
    ReportLanguage: number;
    Report5YearAgeGap: boolean;
    LeaveTypes: string;
    AttributeList: any[];
    DiasBaja: number;
}

export class EstudioReports {
    Title = '';
    CompanyId: number = 0;
    AttributeName: string = '';
    AttributeIndex: number;
    Portada = false;
    CuadroDeMando = false;
    AbsMensual = false;
    AbsAcumulado = false;
    BajasActivas = false;
    BajasComunicadas = false;
    GapsDeBaja = false;
    DuracionMedia = false;
    Diagnostico = false;
    Edades = false;
    DiagnEdad = false;
    Genero = false;
    DiagnGenero = false;
    DiagnEdadGenero = false;
    DiasDeLaSemana = false;
}

export class EstudioTemplate {
    TemplateId: number;
    Name: string;
    ReportList = new Array<EstudioReports>();
    Parameters: EstudioParameters;
}
